import React from "react";
import { FaRegComment } from "react-icons/fa";
import { useIonRouter, IonIcon, IonButton } from "@ionic/react";
import { chatbubbleOutline } from "ionicons/icons";
import formatCount from "../../utils/formatCount";
const ReplyBtn = ({ replies, id }) => {
  const router = useIonRouter();

  return (
    <IonButton
      fill="clear"
      size="small"
      shape="round"
      className="sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn ion-no-padding"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        router.push(`/post/${id}`);
      }}
    >
      <IonIcon icon={chatbubbleOutline} />
      <p>{formatCount(replies)}</p>
    </IonButton>
  );
};

export default ReplyBtn;

